import React from 'react';
import { Button, InputGroup, InputGroupText, Input } from 'reactstrap';
import { noop } from 'lodash';
import Icon from 'jsx/components/core/icons/Icon';

const SingleSearch = ({
  handleSearchChange = noop,
  onSearch,
  value,
  placeholder = '',
  inputGroupClassName = 'mr-2',
}) => {
  return (
    <InputGroup style={{ width: 300 }} className={inputGroupClassName} size="sm">
      <InputGroupText>
        <Icon name="magnifying-glass" />
      </InputGroupText>
      <Input
        className="h-auto"
        placeholder={placeholder}
        onChange={handleSearchChange}
        onKeyDown={handleSearchChange}
        value={value}
      />
      {onSearch && (
        <Button color="success" onClick={onSearch}>
          Go
        </Button>
      )}
    </InputGroup>
  )
};

export default SingleSearch;
